import React, { useEffect, useState } from 'react';
import CourseCard, { CourseCardSkeleton } from './CourseCard';
import instance from '../../api/axios/utils.ts/instance';
import { CommonResProps } from '../../constants/types';
import { legacyCourseListType } from '../../constants/legacyTypes';
import { AppProductListOrderBy, ProductSubType, ProductType } from '../../enum';

const GRID_CLASS =
  'mb-8 grid w-full grid-cols-1 flex-wrap gap-8 p-4 sm:grid-cols-2 lg:grid-cols-4 lg:p-0';

/**
 * 서브타입(카테고리)별 코스 목록
 * 한 화면에 여러 개가 동시에 뜨므로(메인 페이지) 목록 상태는 컴포넌트 안에만 둔다.
 */
const CourseList = ({
  productSubType,
  max,
}: {
  productSubType: ProductSubType;
  max?: number;
}) => {
  const [courses, setCourses] = useState<legacyCourseListType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);

    instance
      .get<CommonResProps<legacyCourseListType[]>>('/v1/product', {
        params: {
          product_type: ProductType.COURSE,
          product_sub_type: productSubType,
          order_by: AppProductListOrderBy.RECOMMENDED,
        },
      })
      .then(({ data }) => {
        if (alive) setCourses(data.result ?? []);
      })
      .catch((err) => console.error('코스 목록 조회 실패', err))
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, [productSubType]);

  /** 스켈레톤. 카드 영역 높이를 실제 목록과 맞춰 로딩 후 레이아웃이 밀리지 않게 한다 */
  if (loading) {
    return (
      <div className={GRID_CLASS}>
        {Array.from({ length: max ?? 4 }, (_, i) => (
          <CourseCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  const visible = courses
    .filter((data) => data.product_sub_type === productSubType)
    .slice(0, max);

  if (!visible.length) return null;

  return (
    <div className={GRID_CLASS}>
      {visible.map((data) => (
        <CourseCard data={data} key={data.id} />
      ))}
    </div>
  );
};

export default CourseList;
